module.exports = "/_next/static/images/baseballIcon@3x-4d0658631acad8b11a8bcc1a892ed6d7.png";